<template>
    <select class="form-control" ref="root" :disabled="disabled">
        <option
            v-for="option in options"
            :value="option.id"
            :key="option.id"
            :data-test="`${$props.dataTestOptions}Duration-${option.name}`"
        >
            {{ option.name }}
        </option>
    </select>
</template>

<script lang="ts">
// https://stackoverflow.com/a/43548190
// https://vuejs.org/v2/examples/select2.html

import { defineComponent, onMounted, ref, watch, watchEffect, nextTick } from "vue";
import { SelectBoxOption } from "../model/select-box-option";
import { initSelectBoxIt } from "@/shared/components/select-box";
import $ from "jquery";

export default defineComponent({
    name: "SelectBox",
    props: {
        modelValue: [Number, String],
        options: {
            type: Array as () => SelectBoxOption[],
            required: true,
            default: () => [],
        },
        useStringValues: {
            type: Boolean,
            default: false,
        },
        dataTestOptions: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["update:modelValue", "blur"],

    setup(props, ctx) {
        const root = ref<HTMLSelectElement | null>(null);
        let selectBoxIt = null;

        function initSelectboxit() {
            selectBoxIt = $(root.value)?.data("selectBox-selectBoxIt");

            // dont do anything if selectbox is already initialized
            if (selectBoxIt) {
                return;
            }
            initSelectBoxIt(root.value);
            selectBoxIt = $(root.value)?.data("selectBox-selectBoxIt");
            root.value.querySelectorAll(".selectboxit-option").forEach((el) => {
                (el as HTMLElement).dataset.test = (el as HTMLElement).dataset.val;
            });
        }

        onMounted(() => {
            initSelectboxit();
            selectBoxIt.selectOption(`${props.modelValue}`);

            root.value.addEventListener("change", () => {
                if (!root.value.selectedOptions?.length) return;

                const value = root.value.selectedOptions[0].value;
                if (props.useStringValues) {
                    ctx.emit("update:modelValue", value);
                    return;
                }
                const numericValue = /^[-+]?(\d+)$/.test(value) ? Number(value) : NaN;
                ctx.emit("update:modelValue", isNaN(numericValue) ? value : numericValue);
            });

            $(root.value).on("blur", () => {
                ctx.emit("blur");
            });

            watchEffect(() => {
                selectBoxIt.refresh();
            });

            watch(
                () => props.options,
                () => {
                    nextTick(() => {
                        selectBoxIt.selectOption(`${props.modelValue}`);
                        selectBoxIt.refresh();
                    });
                }
            );

            watch(
                () => props.modelValue,
                () => {
                    nextTick(() => {
                        selectBoxIt.selectOption(`${props.modelValue}`);
                        selectBoxIt.refresh();
                    });
                }
            );

            watch(
                () => props.disabled,
                () => (props.disabled ? selectBoxIt.disable() : selectBoxIt.enable())
            );
        });

        return {
            root,
        };
    },
});
</script>
